<template>
  <div>
    <!-- Titulo -->
    <div
      @click="openBomb"
      style="
        position: absolute;
        top: -25%; /* Ajusta para que esté arriba del canvas */
        left: 50%; /* Centrado horizontalmente */
        transform: translateX(-50%);
        color: black;
        font-size: min(calc(1vw + 4px), 16px);
        font-weight: bold;
        z-index: 2;
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 1;
        padding: 0;
        text-align: center; /* Centra el texto horizontalmente */
      "
    >
      <!-- <span class="bomb-id">{{ input.customized.name }}</span> -->
      <span v-if="!is_electrovalv"class="bomb-name">{{ getBombName(input.customized.name) }}</span>
    </div>

    <!-- Bombas -->
    <canvas
      @click="openBomb"
      ref="motorCanvas"
      width="100" 
      height="100" 
      style="position: absolute; width: 100%; height: 80%; cursor: pointer"
    ></canvas>

    <!-- Mostrar bombas -->
    <v-dialog v-if="!editing" v-model="showBomb" max-width="500">
      <v-card
        class="custom-card bomb-card"
        style="height: inherit"
      >
        <v-card-title
          class="d-flex flex-column align-start pt-2 pb-2"
          :style="{ backgroundColor: bombFailureAlarmValue ? `red` : `#e3eef9` }"
        >
          <div class="table-title">
            {{ `${nombresBombas.find(bomba => bomba.id == input.customized.name).id} 
                ${nombresBombas.find(bomba => bomba.id == input.customized.name).nombre}` }}
          </div>
        </v-card-title>

        <v-card-text class="mt-2 pt-1">
          <!-- Marcha/Paro -->
          <div v-if="!input.customized.variable_is_auto_manual">
            <v-row v-if="!only_read">
              <v-col cols="4">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(true)"
                >
                  MARCHA
                </v-btn>
              </v-col>
              <v-col cols="4">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(false)"
                >
                PARO
                </v-btn>
              </v-col>
              <v-col cols="4">
                <div class="centered-div">
                  <v-icon
                    class="mt-0"
                    medium
                    :color="continuousRunningValue ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
            <!-- Solo lectura marcha/paro -->
            <v-row v-else>
              Marcha de bomba desde armario local con control de nivel
              <v-col cols="1">
                <div class="centered-div">
                  <v-icon
                    class="mt-0"
                    medium
                    :color="continuousRunningValue ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Automatico/Manual/Paro -->
          <div v-else>
            <v-row v-if="!only_read">
              <v-col cols="3" class="d-flex justify-center">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  :class="{ 'selected-button': selectedButton === 2 }"
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(2)"
                >
                  AUTOMÁTICO
                </v-btn>
              </v-col>
              <v-col cols="3" class="d-flex justify-center">
                <v-btn
                  v-if="!input.customized.es_auto"
                  elevation="2"
                  outlined
                  block
                  small
                  :class="{ 'selected-button': selectedButton === 1 }"
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(1)"
                >
                  MARCHA
                </v-btn>
              </v-col>
              <v-col cols="3" class="d-flex justify-center">
                <v-btn
                  elevation="2"
                  outlined
                  block
                  small
                  style="background-color: #e3eef9"
                  color="rgb(61, 59, 59)"
                  @click="setRunOrderValue(0)"
                >
                PARO
                </v-btn>
              </v-col>
              <v-col cols="3">
                <div class="centered-div">
                  <v-icon
                    class="mt-0"
                    medium
                    :color="continuousRunningValue ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
            <v-row v-else class="w-100 d-flex align-center justify-center">
              <!-- AUTOMATICO -->
              <v-col cols="4" class="d-flex justify-center">
                <div class="d-flex align-center">
                  <span>AUTOMÁTICO</span>
                  <v-icon
                    class="ml-2"
                    medium
                    :color="selectedButton === 2 ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>

              <!-- Separador -->
              <v-col cols="auto" class="d-flex align-center">
                <v-divider vertical></v-divider>
              </v-col>

              <!-- MARCHA -->
              <v-col cols="4" class="d-flex justify-center">
                <div class="d-flex align-center">
                  <span>MARCHA</span>
                  <v-icon
                    class="ml-2"
                    medium
                    :color="continuousRunningValue ? `green` : `#7e827f`"
                    dark
                  >
                    mdi-circle
                  </v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="input.customized.text_bomb || (input.customized.text_marcha && selectedButton == 1) || (input.customized.text_auto && selectedButton == 2)">
            <v-col cols="12" class="text-center mt-2">
              <v-alert dense outlined type="info">
                {{ selectedButton && input.customized.text_marcha && input.customized.text_marcha ? 
                    selectedButton == 1 ? input.customized.text_marcha: input.customized.text_auto : 
                    input.customized.text_bomb }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="!isLaboratory()">
          <v-spacer></v-spacer>
          <v-btn
            v-if="input.customized.variator_speed_configuration?.customized.address"
            icon
            @click="showVariatorSpeedDialog = true"
          >
            <v-icon>mdi-car-speed-limiter</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showVariatorSpeedDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Configurar velocidad del variador de {{ input.customized.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.variator_speed_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.variator_speed_configuration">
                  <component
                    :is="input.customized.variator_speed_configuration.settings.component_type"
                    :input="input.customized.variator_speed_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVariatorSpeedDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";

import MotorApagadoImageSrc from "@/plugins/bomb_canvas/assets/motorApagado.svg";
import MotorEncendidoImageSrc from "@/plugins/bomb_canvas/assets/motorEncendido.svg";
import MotorAlarmaImageSrc from "@/plugins/bomb_canvas/assets/motorAlarma.svg"

import MApagadoSrc from "@/plugins/bomb_canvas/assets/mApagado.svg"
import MEncendidoSrc from "@/plugins/bomb_canvas/assets/mEncendido.svg"
import MAlarmaSrc from "@/plugins/bomb_canvas/assets/mAlarma.svg"

import ElectroValvulaApagadoImageSrc from "@/plugins/bomb_canvas/assets/electrovalvulaApagada.png";
import ElectroValvulaEncendidoImageSrc from "@/plugins/bomb_canvas/assets/electrovalvulaEncendida.png";
import ElectroValvulaAlarmaImageSrc from "@/plugins/bomb_canvas/assets/electrovalvulaAlarma.png";


import MoveableComponent from "@/components/generic/MoveableComponent.vue";
export default {
  name: "koiote-bomb-canvas-quesos",

  props: {
    input: Object,
  },
  components: {
    MoveableComponent,
  },
  data() {
    return {
      nombresBombas: [
        { "id": "M18", "nombre": "Bomba Multivías" },
        { "id": "M27", "nombre": "Bomba embudo grande" },
        { "id": "M28", "nombre": "Bomba Vibrador" },
        { "id": "M29", "nombre": "Motor Vibrador" },
        { "id": "M30", "nombre": "Bomba Separador" },
        { "id": "M31", "nombre": "Motor Separador" },
        { "id": "M32", "nombre": "Bomba lleva suero a finos" },
        { "id": "M33", "nombre": "Bomba recuperar suero de mesa finos" },
        { "id": "M34", "nombre": "Bomba embudo pequeña" },
        { "id": "M35", "nombre": "Bomba agua a pasteurizadora" },
        { "id": "M36", "nombre": "Bomba descarga de leche" },
        { "id": "M37", "nombre": "Bomba carga suero" },
        { "id": "M38", "nombre": "BRC1" },
        { "id": "M39", "nombre": "Bomba leche a pasteurizadora" },
        {"id": "M17", "nombre": "Bomba pozo"},
        { "id": "EV35", "nombre": "ElectroValvula anti retorno de agua a pasteurizadora" },
        { "id": "EV39", "nombre": "ElectroValvula anti retorno de leche a pasteurizadora" }
      ],

      showVariatorSpeedDialog: false,
      showTooltip: false,
      
      electrovalvulaApagadaImage: null,
      electrovalvulaEncendidaImage: null,
      electrovalvulaAlarmaImage: null,
      
      motorApagadoImage: null,
      motorEncendidoImage: null,
      motorAlarmaImage: null,

      mApagadoImage: null,
      mEncendidoImage: null,
      mAlarmaImage: null,

      showBomb: false,
      labelCanvasStyle: {
        position: "absolute",
        height: "40%",
        top: "10%",
        left: "20%",
        zIndex: 2,
        background: "rgba(255, 255, 255, 0.6)",
        border: "1px solid black",
        width: "0px",
        cursor: "pointer"
      }
    };
  },

  computed: {
    ...mapState(["editing"]),

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable;
    },
    allImagesLoaded() {
      return this.motorApagadoImage != null && this.motorEncendidoImage != null && this.motorAlarmaImage != null &&
              this.electrovalvulaAlarmaImage != null && this.electrovalvulaApagadaImage != null && this.electrovalvulaEncendidaImage != null;
    },
    //Bombas
    bombFailureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_bomb_failure_alarm)?.value;
    },
    continuousRunningValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_continuous_running)
        ?.value;
    },
    write_topic() {
    return this.actualPage().global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection")
      .customized.topic_write;
    },
    only_read() {
      return this.input.customized.only_read;
    },
    is_electrovalv() {
      return this.input.customized.is_electrovalvula;
    },
    is_motor(){
      return this.input.customized.is_motor;
    },
    selectedButton() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.auto_manu_read_address)
        ?.value;
    },
    rotation(){
      return this.input.customized.rotation;
    }
  },

  methods: {
    ...mapGetters(["actualPage", "isProduction", "isLaboratory", "isManteni"]),
    ...mapActions("nodered", ["doPublish"]),

    openBomb(){
      if (this.isManteni()) return;
      this.showBomb = true;
    },

    getBombName(id) {
      const bomba = this.nombresBombas.find(b => b.id === id);
      if (!bomba) {
        return '';
      }

      let nombre = bomba.nombre;

      // Reemplazos
      nombre = nombre
        .replace(/\bBomba\b/g, 'B. ')
        .replace(/\bMotor\b/g, 'M. ')
        .replace(/\bElectroValvula anti retorno de \b/g, 'EV. ');

      return nombre.toUpperCase();
    },

    // Bombas ---------------------------------------------------------------------------
    async makeMotorBomba() {
      const canvas = this.$refs.motorCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const bomba = this.bombFailureAlarmValue
        ? this.motorAlarmaImage
        : this.continuousRunningValue
        ? this.motorEncendidoImage
        : this.motorApagadoImage;

      const motor = this.bombFailureAlarmValue
        ? this.mAlarmaImage
        : this.continuousRunningValue
        ? this.mEncendidoImage
        : this.mApagadoImage;

      const electrovalv = this.bombFailureAlarmValue
        ? this.electrovalvulaAlarmaImage
        : this.continuousRunningValue
        ? this.electrovalvulaEncendidaImage
        : this.electrovalvulaApagadaImage;

      const img = this.is_electrovalv
        ? electrovalv
        : this.is_motor
        ? motor
        : bomba;

      if (!img) return;

      // Obtener ángulo de rotación en grados y convertir a radianes
      const rotationDeg = parseInt(this.rotation) || 0; // fallback a 0 si no existe
      const rotationRad = (rotationDeg * Math.PI) / 180;

      // Guardar el estado actual del contexto
      ctx.save();

      // Trasladar el origen al centro del canvas
      ctx.translate(canvas.width / 2, canvas.height / 2);

      // Aplicar rotación
      ctx.rotate(rotationRad);

      // Dibujar la imagen centrada en el origen (ahora rotado)
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      ctx.drawImage(img, -imgWidth / 2, -imgHeight / 2, imgWidth, imgHeight);

      // Restaurar el estado original del contexto
      ctx.restore();
    },

    //cargar imagenes de electrovalvulas
    loadElectrovalvulaApagadaImage() {
      const img = new Image();
      img.src = ElectroValvulaApagadoImageSrc;
      img.onload = () => (this.electrovalvulaApagadaImage = img);
    },
    loadElectrovalvulaEncendidaImage() {
      const img = new Image();
      img.src = ElectroValvulaEncendidoImageSrc
      img.onload = () => (this.electrovalvulaEncendidaImage = img);
    },
    loadElectrovalvulaAlarmaImage() {
      const img = new Image();
      img.src = ElectroValvulaAlarmaImageSrc;
      img.onload = () => (this.electrovalvulaAlarmaImage = img);
    },

    //cargar imagenes de motores
    loadMotorApagadoImage() {
      const img = new Image();
      img.src = MotorApagadoImageSrc;
      img.onload = () => (this.motorApagadoImage = img);
    },

    loadMotorEncendidoImage() {
      const img = new Image();
      img.src = MotorEncendidoImageSrc;
      img.onload = () => (this.motorEncendidoImage = img);
    },

    loadMotorAlarmaImage() {
      const img = new Image();
      img.src = MotorAlarmaImageSrc;
      img.onload = () => (this.motorAlarmaImage = img);
    },

    // cargar imagenes de motores
    loadMApagadoImage() {
      const img = new Image();
      img.src = MApagadoSrc;
      img.onload = () => (this.mApagadoImage = img);
    },

    loadMEncendidoImage() {
      const img = new Image();
      img.src = MEncendidoSrc;
      img.onload = () => (this.mEncendidoImage = img);
    },

    loadMAlarmaImage() {
      const img = new Image();
      img.src = MAlarmaSrc;
      img.onload = () => (this.mAlarmaImage = img);
    },


    setRunOrderValue(value) {
      const stateMap = {
        true: 'MARCHA',
        1: 'MARCHA',
        false: 'PARO',
        0: 'PARO',
        2: 'AUTOMÁTICO'
      };

      const stateText = stateMap[value] || 'DESCONOCIDO';

      const variableToChange = this.vartable.find(
        (v) => v.formatted_address == this.input.customized.variable_run_order
      );
      variableToChange.value = value;
      this.doPublish({
        topic: this.write_topic,
        message: {
          address: variableToChange.address,
          value: this.adaptFormat({ type: "BIT", value }),
        },
        description: `${this.getBombName(this.input.customized.name)} en ${stateText}`
      });
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },

    setCanvasWidth() {
      const bombCanvas = this.$refs.motorCanvas;
      if (bombCanvas) {
        // console.log("Si que esta tankcanvas")
        const bombCanvasWidth = bombCanvas.offsetWidth * 0.63;
        this.labelCanvasStyle.width = `${bombCanvasWidth}px`;
      }else {
        console.log("no esta tankcanvas")
      }
    }
  },

  mounted() {
    this.loadMotorEncendidoImage();
    this.loadMotorApagadoImage();
    this.loadMotorAlarmaImage();

    this.loadMAlarmaImage();
    this.loadMEncendidoImage();
    this.loadMApagadoImage();

    this.loadElectrovalvulaAlarmaImage();
    this.loadElectrovalvulaApagadaImage();
    this.loadElectrovalvulaEncendidaImage();

    this.setCanvasWidth();
    window.addEventListener("resize", this.setCanvasWidth);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setCanvasWidth);
  },

  watch: {

    continuousRunningValue() {
      this.makeMotorBomba();
    },
    bombFailureAlarmValue() {
      this.makeMotorBomba();
    },
    allImagesLoaded(value) {
      if (value) {
        this.makeMotorBomba();
      }
    },
    rotation() {
      this.makeMotorBomba();
    },

    input: {
      handler() {
        this.makeMotorBomba();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.tooltip {
  /* Opcional: Estilo del tooltip */
  font-size: 12px;
  opacity: 0.9;
  transition: opacity 0.2s ease;
}
.selected-button {
  border: 4px solid green; /* Estilo del borde verde */
  border-radius: 4px; /* Mantiene el diseño redondeado del botón */
}
.status-box {
  border: 2px solid transparent; /* Borde invisible por defecto */
  border-radius: 8px; /* Bordes redondeados */
  padding: 4px 8px;
  font-weight: bold;
  text-align: center;
  transition: border 0.3s ease-in-out;
}

.active-status {
  border-color: green; /* Borde verde cuando selectedButton es 2 */
  color: green;
}

.bomb-id {
  font-size: 1em;
}

.bomb-name {
  font-size: 0.6em; /* Más pequeño que el ID */
  color: gray;
  white-space: nowrap;
  margin-top: 2px;
}

/* Ocultar el nombre en pantallas pequeñas */
@media (max-width: 768px) {
  .bomb-name {
    display: none;
  }
}
</style>
